export const isValidSession = session => {
  if (!session.ok) {
    return false
  }
  if (!(session.userCtx && session.userCtx.name)) {
    return false
  }
  return true
}



// WEBPACK FOOTER //
// ./src/login/session.js